module.exports = __webpack_public_path__ + "static/media/sentiment_satisfied_v2.1cf9f05f.svg";